import {BindGroupConfig} from '@mintdata/mint-kit/api/decorators/Editor';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';

export abstract class BoxBindGroups
{
    public static readonly MAIN_GROUP = 'main';

    public static forEditor()
    {
        return {
            [BoxBindGroups.MAIN_GROUP]: new BindGroupConfig(BoxBindGroups.MAIN_GROUP,
                [
                    ...BoxMainFieldPaths.all(),

                    ...BoxNormalStateFieldPaths.all(),
                    ...BoxHoverStateFieldPaths.all(),
                    ...BoxActiveStateFieldPaths.all(),
                ],
            ),
        };
    }
}

export abstract class BoxMainFieldPaths
{
    public static readonly OVERFLOW_X:FieldPath = 'overflowX';
    public static readonly OVERFLOW_Y:FieldPath = 'overflowY';

    public static readonly PADDING:FieldPath = 'padding.value';
    public static readonly PADDING_LEFT:FieldPath = 'padding.left';
    public static readonly PADDING_TOP:FieldPath = 'padding.top';
    public static readonly PADDING_RIGHT:FieldPath = 'padding.right';
    public static readonly PADDING_BOTTOM:FieldPath = 'padding.bottom';

    public static readonly IS_HOVER_EVENT_PROPAGATION_ENABLED:FieldPath = 'isHoverEventPropagationEnabled';
    public static readonly HOVER_EVENT_PROPAGATION:FieldPath = 'hoverEventPropagation';
    public static readonly IS_ACTIVE_EVENT_PROPAGATION_ENABLED:FieldPath = 'isActiveEventPropagationEnabled';

    public static readonly IS_SCROLL_POSITION_ENABLED:FieldPath = 'isScrollPositionEnabled';
    public static readonly VERTICAL_SCROLL_POSITION:FieldPath = 'verticalScrollPosition';
    public static readonly HORIZONTAL_SCROLL_POSITION:FieldPath = 'horizontalScrollPosition';
    public static readonly ACCELERATE_SCROLL_ON_MOBILE:FieldPath = 'accelerateScrollOnMobile';

    public static all():Array<FieldPath>
    {
        return [
            BoxMainFieldPaths.OVERFLOW_X,
            BoxMainFieldPaths.OVERFLOW_Y,

            BoxMainFieldPaths.IS_HOVER_EVENT_PROPAGATION_ENABLED,
            BoxMainFieldPaths.HOVER_EVENT_PROPAGATION,
            BoxMainFieldPaths.IS_ACTIVE_EVENT_PROPAGATION_ENABLED,

            BoxMainFieldPaths.IS_SCROLL_POSITION_ENABLED,
            BoxMainFieldPaths.VERTICAL_SCROLL_POSITION,
            BoxMainFieldPaths.HORIZONTAL_SCROLL_POSITION,
            BoxMainFieldPaths.ACCELERATE_SCROLL_ON_MOBILE,
        ];
    }
}

export abstract class BoxNormalStateFieldPaths
{
    public static all():Array<FieldPath>
    {
        return [
            ...BoxStateFieldPaths.state('NORMAL'),
        ];
    }
}

export abstract class BoxHoverStateFieldPaths
{
    public static readonly HOVER_IS_ENABLED:FieldPath = 'hoverState.isEnabled';

    public static all():Array<FieldPath>
    {
        return [
            BoxHoverStateFieldPaths.HOVER_IS_ENABLED,
            ...BoxStateFieldPaths.state('HOVER'),
        ];
    }
}

export abstract class BoxActiveStateFieldPaths
{
    public static readonly ACTIVE_IS_ENABLED:FieldPath = 'activeState.isEnabled';

    public static all():Array<FieldPath>
    {
        return [
            BoxActiveStateFieldPaths.ACTIVE_IS_ENABLED,
            ...BoxStateFieldPaths.state('ACTIVE'),
        ];
    }
}

export abstract class BoxStateFieldPaths
{
    public static readonly BG_TYPE:FieldPath = 'background.type';
    public static readonly BG_SOLID_HEX:FieldPath = 'background.solidColor.color.hex';
    public static readonly BG_SOLID_ALPHA:FieldPath = 'background.solidColor.color.alpha';
    public static readonly BG_SOLID_RGBA:FieldPath = 'background.solidColor.color.rgba';
    public static readonly BG_SOLID_VISIBILITY:FieldPath = 'background.solidColor.visibility';
    public static readonly BG_GRAD_FROM_HEX:FieldPath = 'background.gradientFromColor.color.hex';
    public static readonly BG_GRAD_FROM_ALPHA:FieldPath = 'background.gradientFromColor.color.alpha';
    public static readonly BG_GRAD_FROM_RGBA:FieldPath = 'background.gradientFromColor.color.rgba';
    public static readonly BG_GRAD_FROM_VISIBILITY:FieldPath = 'background.gradientFromColor.visibility';
    public static readonly BG_GRAD_TO_HEX:FieldPath = 'background.gradientToColor.color.hex';
    public static readonly BG_GRAD_TO_ALPHA:FieldPath = 'background.gradientToColor.color.alpha';
    public static readonly BG_GRAD_TO_RGBA:FieldPath = 'background.gradientToColor.color.rgba';
    public static readonly BG_GRAD_TO_VISIBILITY:FieldPath = 'background.gradientToColor.visibility';
    public static readonly BG_GRAD_ANGLE:FieldPath = 'background.gradientAngle';

    public static readonly BORDER_RADIUS:FieldPath = 'border.borderRadius.value';
    public static readonly BORDER_RADIUS_BOTTOM_LEFT:FieldPath = 'border.borderRadius.bottomLeft';
    public static readonly BORDER_RADIUS_BOTTOM_RIGHT:FieldPath = 'border.borderRadius.bottomRight';
    public static readonly BORDER_RADIUS_TOP_LEFT:FieldPath = 'border.borderRadius.topLeft';
    public static readonly BORDER_RADIUS_TOP_RIGHT:FieldPath = 'border.borderRadius.topRight';
    public static readonly BORDER_COLOR_HEX:FieldPath = 'border.borderColor.color.hex';
    public static readonly BORDER_COLOR_ALPHA:FieldPath = 'border.borderColor.color.alpha';
    public static readonly BORDER_COLOR_RGBA:FieldPath = 'border.borderColor.color.rgba';
    public static readonly BORDER_COLOR_VISIBILITY:FieldPath = 'border.borderColor.visibility';
    public static readonly BORDER_THICKNESS:FieldPath = 'border.borderThickness.unitsString';
    public static readonly BORDER_STYLE:FieldPath = 'border.borderStyle';
    public static readonly BORDER_FILL:FieldPath = 'border.borderFill';

    public static readonly BOXSHADOW_COLOR_HEX:FieldPath = 'boxShadow.color.color.hex';
    public static readonly BOXSHADOW_COLOR_ALPHA:FieldPath = 'boxShadow.color.color.alpha';
    public static readonly BOXSHADOW_COLOR_RGBA:FieldPath = 'boxShadow.color.color.rgba';
    public static readonly BOXSHADOW_COLOR_VISIBILITY:FieldPath = 'boxShadow.color.visibility';
    public static readonly BOXSHADOW_DELTAX:FieldPath = 'boxShadow.deltaX.unitsString';
    public static readonly BOXSHADOW_DELTAY:FieldPath = 'boxShadow.deltaY.unitsString';
    public static readonly BOXSHADOW_BLUR:FieldPath = 'boxShadow.blur.unitsString';
    public static readonly BOXSHADOW_SPREAD:FieldPath = 'boxShadow.spread.unitsString';

    public static readonly INNERSHADOW_COLOR_HEX:FieldPath = 'innerShadow.color.color.hex';
    public static readonly INNERSHADOW_COLOR_ALPHA:FieldPath = 'innerShadow.color.color.alpha';
    public static readonly INNERSHADOW_COLOR_RGBA:FieldPath = 'innerShadow.color.color.rgba';
    public static readonly INNERSHADOW_COLOR_VISIBILITY:FieldPath = 'innerShadow.color.visibility';
    public static readonly INNERSHADOW_DELTAX:FieldPath = 'innerShadow.deltaX.unitsString';
    public static readonly INNERSHADOW_DELTAY:FieldPath = 'innerShadow.deltaY.unitsString';
    public static readonly INNERSHADOW_BLUR:FieldPath = 'innerShadow.blur.unitsString';
    public static readonly INNERSHADOW_SPREAD:FieldPath = 'innerShadow.spread.unitsString';

    public static readonly IS_BG_BLUR_ENABLED:FieldPath = 'blur.isBgBlurEnabled';
    public static readonly BG_BLUR:FieldPath = 'blur.bgBlur.unitsString';
    public static readonly IS_CONTENT_BLUR_ENABLED:FieldPath = 'blur.isContentBlurEnabled';
    public static readonly CONTENT_BLUR:FieldPath = 'blur.contentBlur.unitsString';

    // hover
    public static readonly HOVER_BG_TYPE:FieldPath = 'hoverState.background.type';
    public static readonly HOVER_BG_SOLID_HEX:FieldPath = 'hoverState.background.solidColor.color.hex';
    public static readonly HOVER_BG_SOLID_ALPHA:FieldPath = 'hoverState.background.solidColor.color.alpha';
    public static readonly HOVER_BG_SOLID_RGBA:FieldPath = 'hoverState.background.solidColor.color.rgba';
    public static readonly HOVER_BG_SOLID_VISIBILITY:FieldPath = 'hoverState.background.solidColor.visibility';
    public static readonly HOVER_BG_GRAD_FROM_HEX:FieldPath = 'hoverState.background.gradientFromColor.color.hex';
    public static readonly HOVER_BG_GRAD_FROM_ALPHA:FieldPath = 'hoverState.background.gradientFromColor.color.alpha';
    public static readonly HOVER_BG_GRAD_FROM_RGBA:FieldPath = 'hoverState.background.gradientFromColor.color.rgba';
    public static readonly HOVER_BG_GRAD_FROM_VISIBILITY:FieldPath = 'hoverState.background.gradientFromColor.visibility';
    public static readonly HOVER_BG_GRAD_TO_HEX:FieldPath = 'hoverState.background.gradientToColor.color.hex';
    public static readonly HOVER_BG_GRAD_TO_ALPHA:FieldPath = 'hoverState.background.gradientToColor.color.alpha';
    public static readonly HOVER_BG_GRAD_TO_RGBA:FieldPath = 'hoverState.background.gradientToColor.color.rgba';
    public static readonly HOVER_BG_GRAD_TO_VISIBILITY:FieldPath = 'hoverState.background.gradientToColor.visibility';
    public static readonly HOVER_BG_GRAD_ANGLE:FieldPath = 'hoverState.background.gradientAngle';

    public static readonly HOVER_BORDER_RADIUS:FieldPath = 'hoverState.border.borderRadius.value';
    public static readonly HOVER_BORDER_RADIUS_BOTTOM_LEFT:FieldPath = 'hoverState.border.borderRadius.bottomLeft';
    public static readonly HOVER_BORDER_RADIUS_BOTTOM_RIGHT:FieldPath = 'hoverState.border.borderRadius.bottomRight';
    public static readonly HOVER_BORDER_RADIUS_TOP_LEFT:FieldPath = 'hoverState.border.borderRadius.topLeft';
    public static readonly HOVER_BORDER_RADIUS_TOP_RIGHT:FieldPath = 'hoverState.border.borderRadius.topRight';
    public static readonly HOVER_BORDER_COLOR_HEX:FieldPath = 'hoverState.border.borderColor.color.hex';
    public static readonly HOVER_BORDER_COLOR_ALPHA:FieldPath = 'hoverState.border.borderColor.color.alpha';
    public static readonly HOVER_BORDER_COLOR_RGBA:FieldPath = 'hoverState.border.borderColor.color.rgba';
    public static readonly HOVER_BORDER_COLOR_VISIBILITY:FieldPath = 'hoverState.border.borderColor.visibility';
    public static readonly HOVER_BORDER_THICKNESS:FieldPath = 'hoverState.border.borderThickness.unitsString';
    public static readonly HOVER_BORDER_STYLE:FieldPath = 'hoverState.border.borderStyle';
    public static readonly HOVER_BORDER_FILL:FieldPath = 'hoverState.border.borderFill';

    public static readonly HOVER_BOXSHADOW_COLOR_HEX:FieldPath = 'hoverState.boxShadow.color.color.hex';
    public static readonly HOVER_BOXSHADOW_COLOR_ALPHA:FieldPath = 'hoverState.boxShadow.color.color.alpha';
    public static readonly HOVER_BOXSHADOW_COLOR_RGBA:FieldPath = 'hoverState.boxShadow.color.color.rgba';
    public static readonly HOVER_BOXSHADOW_COLOR_VISIBILITY:FieldPath = 'hoverState.boxShadow.color.visibility';
    public static readonly HOVER_BOXSHADOW_DELTAX:FieldPath = 'hoverState.boxShadow.deltaX.unitsString';
    public static readonly HOVER_BOXSHADOW_DELTAY:FieldPath = 'hoverState.boxShadow.deltaY.unitsString';
    public static readonly HOVER_BOXSHADOW_BLUR:FieldPath = 'hoverState.boxShadow.blur.unitsString';
    public static readonly HOVER_BOXSHADOW_SPREAD:FieldPath = 'hoverState.boxShadow.spread.unitsString';

    public static readonly HOVER_INNERSHADOW_COLOR_HEX:FieldPath = 'hoverState.innerShadow.color.color.hex';
    public static readonly HOVER_INNERSHADOW_COLOR_ALPHA:FieldPath = 'hoverState.innerShadow.color.color.alpha';
    public static readonly HOVER_INNERSHADOW_COLOR_RGBA:FieldPath = 'hoverState.innerShadow.color.color.rgba';
    public static readonly HOVER_INNERSHADOW_COLOR_VISIBILITY:FieldPath = 'hoverState.innerShadow.color.visibility';
    public static readonly HOVER_INNERSHADOW_DELTAX:FieldPath = 'hoverState.innerShadow.deltaX.unitsString';
    public static readonly HOVER_INNERSHADOW_DELTAY:FieldPath = 'hoverState.innerShadow.deltaY.unitsString';
    public static readonly HOVER_INNERSHADOW_BLUR:FieldPath = 'hoverState.innerShadow.blur.unitsString';
    public static readonly HOVER_INNERSHADOW_SPREAD:FieldPath = 'hoverState.innerShadow.spread.unitsString';

    public static readonly HOVER_IS_BG_BLUR_ENABLED:FieldPath = 'hoverState.blur.isBgBlurEnabled';
    public static readonly HOVER_BG_BLUR:FieldPath = 'hoverState.blur.bgBlur.unitsString';
    public static readonly HOVER_IS_CONTENT_BLUR_ENABLED:FieldPath = 'hoverState.blur.isContentBlurEnabled';
    public static readonly HOVER_CONTENT_BLUR:FieldPath = 'hoverState.blur.contentBlur.unitsString';

    // active
    public static readonly ACTIVE_BG_TYPE:FieldPath = 'activeState.background.type';
    public static readonly ACTIVE_BG_SOLID_HEX:FieldPath = 'activeState.background.solidColor.color.hex';
    public static readonly ACTIVE_BG_SOLID_ALPHA:FieldPath = 'activeState.background.solidColor.color.alpha';
    public static readonly ACTIVE_BG_SOLID_RGBA:FieldPath = 'activeState.background.solidColor.color.rgba';
    public static readonly ACTIVE_BG_SOLID_VISIBILITY:FieldPath = 'activeState.background.solidColor.visibility';
    public static readonly ACTIVE_BG_GRAD_FROM_HEX:FieldPath = 'activeState.background.gradientFromColor.color.hex';
    public static readonly ACTIVE_BG_GRAD_FROM_ALPHA:FieldPath = 'activeState.background.gradientFromColor.color.alpha';
    public static readonly ACTIVE_BG_GRAD_FROM_RGBA:FieldPath = 'activeState.background.gradientFromColor.color.rgba';
    public static readonly ACTIVE_BG_GRAD_FROM_VISIBILITY:FieldPath = 'activeState.background.gradientFromColor.visibility';
    public static readonly ACTIVE_BG_GRAD_TO_HEX:FieldPath = 'activeState.background.gradientToColor.color.hex';
    public static readonly ACTIVE_BG_GRAD_TO_ALPHA:FieldPath = 'activeState.background.gradientToColor.color.alpha';
    public static readonly ACTIVE_BG_GRAD_TO_RGBA:FieldPath = 'activeState.background.gradientToColor.color.rgba';
    public static readonly ACTIVE_BG_GRAD_TO_VISIBILITY:FieldPath = 'activeState.background.gradientToColor.visibility';
    public static readonly ACTIVE_BG_GRAD_ANGLE:FieldPath = 'activeState.background.gradientAngle';

    public static readonly ACTIVE_BORDER_RADIUS:FieldPath = 'activeState.border.borderRadius.value';
    public static readonly ACTIVE_BORDER_RADIUS_BOTTOM_LEFT:FieldPath = 'activeState.border.borderRadius.bottomLeft';
    public static readonly ACTIVE_BORDER_RADIUS_BOTTOM_RIGHT:FieldPath = 'activeState.border.borderRadius.bottomRight';
    public static readonly ACTIVE_BORDER_RADIUS_TOP_LEFT:FieldPath = 'activeState.border.borderRadius.topLeft';
    public static readonly ACTIVE_BORDER_RADIUS_TOP_RIGHT:FieldPath = 'activeState.border.borderRadius.topRight';
    public static readonly ACTIVE_BORDER_COLOR_HEX:FieldPath = 'activeState.border.borderColor.color.hex';
    public static readonly ACTIVE_BORDER_COLOR_ALPHA:FieldPath = 'activeState.border.borderColor.color.alpha';
    public static readonly ACTIVE_BORDER_COLOR_RGBA:FieldPath = 'activeState.border.borderColor.color.rgba';
    public static readonly ACTIVE_BORDER_COLOR_VISIBILITY:FieldPath = 'activeState.border.borderColor.visibility';
    public static readonly ACTIVE_BORDER_THICKNESS:FieldPath = 'activeState.border.borderThickness.unitsString';
    public static readonly ACTIVE_BORDER_STYLE:FieldPath = 'activeState.border.borderStyle';
    public static readonly ACTIVE_BORDER_FILL:FieldPath = 'activeState.border.borderFill';

    public static readonly ACTIVE_BOXSHADOW_COLOR_HEX:FieldPath = 'activeState.boxShadow.color.color.hex';
    public static readonly ACTIVE_BOXSHADOW_COLOR_ALPHA:FieldPath = 'activeState.boxShadow.color.color.alpha';
    public static readonly ACTIVE_BOXSHADOW_COLOR_RGBA:FieldPath = 'activeState.boxShadow.color.color.rgba';
    public static readonly ACTIVE_BOXSHADOW_COLOR_VISIBILITY:FieldPath = 'activeState.boxShadow.color.visibility';
    public static readonly ACTIVE_BOXSHADOW_DELTAX:FieldPath = 'activeState.boxShadow.deltaX.unitsString';
    public static readonly ACTIVE_BOXSHADOW_DELTAY:FieldPath = 'activeState.boxShadow.deltaY.unitsString';
    public static readonly ACTIVE_BOXSHADOW_BLUR:FieldPath = 'activeState.boxShadow.blur.unitsString';
    public static readonly ACTIVE_BOXSHADOW_SPREAD:FieldPath = 'activeState.boxShadow.spread.unitsString';

    public static readonly ACTIVE_INNERSHADOW_COLOR_HEX:FieldPath = 'activeState.innerShadow.color.color.hex';
    public static readonly ACTIVE_INNERSHADOW_COLOR_ALPHA:FieldPath = 'activeState.innerShadow.color.color.alpha';
    public static readonly ACTIVE_INNERSHADOW_COLOR_RGBA:FieldPath = 'activeState.innerShadow.color.color.rgba';
    public static readonly ACTIVE_INNERSHADOW_COLOR_VISIBILITY:FieldPath = 'activeState.innerShadow.color.visibility';
    public static readonly ACTIVE_INNERSHADOW_DELTAX:FieldPath = 'activeState.innerShadow.deltaX.unitsString';
    public static readonly ACTIVE_INNERSHADOW_DELTAY:FieldPath = 'activeState.innerShadow.deltaY.unitsString';
    public static readonly ACTIVE_INNERSHADOW_BLUR:FieldPath = 'activeState.innerShadow.blur.unitsString';
    public static readonly ACTIVE_INNERSHADOW_SPREAD:FieldPath = 'activeState.innerShadow.spread.unitsString';

    public static readonly ACTIVE_IS_BG_BLUR_ENABLED:FieldPath = 'activeState.blur.isBgBlurEnabled';
    public static readonly ACTIVE_BG_BLUR:FieldPath = 'activeState.blur.bgBlur.unitsString';
    public static readonly ACTIVE_IS_CONTENT_BLUR_ENABLED:FieldPath = 'activeState.blur.isContentBlurEnabled';
    public static readonly ACTIVE_CONTENT_BLUR:FieldPath = 'activeState.blur.contentBlur.unitsString';

    public static state(stateId:string):Array<FieldPath>
    {
        const state:string = stateId === 'NORMAL' ? '' : stateId + '_';

        return [
            BoxStateFieldPaths[`${state}BG_TYPE`],
            BoxStateFieldPaths[`${state}BG_SOLID_HEX`],
            BoxStateFieldPaths[`${state}BG_SOLID_ALPHA`],
            BoxStateFieldPaths[`${state}BG_SOLID_RGBA`],
            BoxStateFieldPaths[`${state}BG_SOLID_VISIBILITY`],
            BoxStateFieldPaths[`${state}BG_GRAD_FROM_HEX`],
            BoxStateFieldPaths[`${state}BG_GRAD_FROM_ALPHA`],
            BoxStateFieldPaths[`${state}BG_GRAD_FROM_RGBA`],
            BoxStateFieldPaths[`${state}BG_GRAD_FROM_VISIBILITY`],
            BoxStateFieldPaths[`${state}BG_GRAD_TO_HEX`],
            BoxStateFieldPaths[`${state}BG_GRAD_TO_ALPHA`],
            BoxStateFieldPaths[`${state}BG_GRAD_TO_RGBA`],
            BoxStateFieldPaths[`${state}BG_GRAD_TO_VISIBILITY`],
            BoxStateFieldPaths[`${state}BG_GRAD_ANGLE`],

            BoxStateFieldPaths[`${state}BORDER_COLOR_HEX`],
            BoxStateFieldPaths[`${state}BORDER_COLOR_ALPHA`],
            BoxStateFieldPaths[`${state}BORDER_COLOR_RGBA`],
            BoxStateFieldPaths[`${state}BORDER_COLOR_VISIBILITY`],
            BoxStateFieldPaths[`${state}BORDER_THICKNESS`],
            BoxStateFieldPaths[`${state}BORDER_STYLE`],
            BoxStateFieldPaths[`${state}BORDER_FILL`],
            BoxStateFieldPaths[`${state}BORDER_RADIUS`],
            BoxStateFieldPaths[`${state}BORDER_RADIUS_BOTTOM_LEFT`],
            BoxStateFieldPaths[`${state}BORDER_RADIUS_BOTTOM_RIGHT`],
            BoxStateFieldPaths[`${state}BORDER_RADIUS_TOP_LEFT`],
            BoxStateFieldPaths[`${state}BORDER_RADIUS_TOP_RIGHT`],

            BoxStateFieldPaths[`${state}BOXSHADOW_COLOR_HEX`],
            BoxStateFieldPaths[`${state}BOXSHADOW_COLOR_ALPHA`],
            BoxStateFieldPaths[`${state}BOXSHADOW_COLOR_RGBA`],
            BoxStateFieldPaths[`${state}BOXSHADOW_COLOR_VISIBILITY`],
            BoxStateFieldPaths[`${state}BOXSHADOW_DELTAX`],
            BoxStateFieldPaths[`${state}BOXSHADOW_DELTAY`],
            BoxStateFieldPaths[`${state}BOXSHADOW_BLUR`],
            BoxStateFieldPaths[`${state}BOXSHADOW_SPREAD`],

            BoxStateFieldPaths[`${state}INNERSHADOW_COLOR_HEX`],
            BoxStateFieldPaths[`${state}INNERSHADOW_COLOR_ALPHA`],
            BoxStateFieldPaths[`${state}INNERSHADOW_COLOR_RGBA`],
            BoxStateFieldPaths[`${state}INNERSHADOW_COLOR_VISIBILITY`],
            BoxStateFieldPaths[`${state}INNERSHADOW_DELTAX`],
            BoxStateFieldPaths[`${state}INNERSHADOW_DELTAY`],
            BoxStateFieldPaths[`${state}INNERSHADOW_BLUR`],
            BoxStateFieldPaths[`${state}INNERSHADOW_SPREAD`],

            BoxStateFieldPaths[`${state}IS_BG_BLUR_ENABLED`],
            BoxStateFieldPaths[`${state}BG_BLUR`],
            BoxStateFieldPaths[`${state}IS_CONTENT_BLUR_ENABLED`],
            BoxStateFieldPaths[`${state}CONTENT_BLUR`],
        ];
    }
}
